import format from "date-fns/format";
import { SERASA_STATUS } from "../constants/constants";

export const getSerasaStatusMessage = (serasaResponse) => {
  if (!serasaResponse) {
    return '';
  }

  const { situation, dateExpire, observation } = serasaResponse;

  switch (situation) {
    case SERASA_STATUS.clean:
    case SERASA_STATUS.irrelevant:
      return `Situação: ${situation} - Data de expiração: ${format(
        new Date(dateExpire),
        "dd/MM/yyyy 'às' HH:mm."
      )}`;
    case SERASA_STATUS.restriction:
    case SERASA_STATUS.undefined:
      return `Situação: ${situation} - Observação: ${observation}`;
    default:
      return `Situação: ${situation}`;
  }
}